import React from 'react';

function convertArrayReturnToHTML(array) {
  return array?.map((item, index) => (
    <React.Fragment key={index}>
      {item}
      <br />
    </React.Fragment>
  ));
}

export default convertArrayReturnToHTML;
